import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@material-ui/core';

import Header from './Header';
import Banner from './Banner';
import Footer from './Footer';
import IdleComponent from './IdleComponent';

const Layout = (props) => {
	return (
		<div className='page-wrapper'>
			<div className='page-content'>
				{props.showMenu ? <Header history={props.history} /> : null}
				{props.showBanner ? <Banner title={props.title} showBackground={props.showBackground} backgroundBanner={props.backgroundBanner} period={props.period} /> : null}
				<Container className='main-container' fixed>
					<IdleComponent history={props.history} />
					{props.children}
				</Container>
			</div>
			{props.showFooter ? <Footer /> : null}
		</div>
	);
};

Layout.propTypes = {
	showMenu: PropTypes.bool,
	showBanner: PropTypes.bool,
	showFooter: PropTypes.bool,
	showBackground: PropTypes.bool,
	backgroundBanner: PropTypes.string,
	title: PropTypes.string,
	history: PropTypes.any,
};

Layout.defaultProps = {
	showMenu: true,
	showBanner: true,
	showFooter: true,
	showBackground: true,
	backgroundBanner: '/assets/img/header-bg.jpg',
	title: 'Parent / Guardian',
};

export default Layout;
